import { createReducer, on } from "@ngrx/store";
import { Form } from "../../../domain/form.interface";
import { Pagination } from "../../../domain/pagination.interface";
import { VersionState } from "../states/version.state";

import {
  loadVersionsList,
  loadVersionsListSuccess,
  loadVersionsListFailure,
  getSelectedVersion,
  getSelectedVersionSuccess,
  getSelectedVersionFailure,
  deleteVersion,
  deleteVersionSuccess,
  deleteVersionFailure,
  addVersion,
  addVersionSuccess,
  addVersionFailure,
  editVersion,
  editVersionFailure,
  editVersionSuccess
} from "../actions/version.actions";

export const initialPagination: Pagination = {
  total: 0,
  pages: 1,
  next: null,
  previous: null,
  current: 1,
  entries: 50,
};

export const initialState: VersionState = {
  versions: null,
  selectedVersion: null,
  error: null,
  listStatus: "pending",
  getStatus: "pending",
  createStatus: "pending",
  updateStatus: "pending",
  deleteStatus: "pending",
  pagination: initialPagination
};

export const versionReducer = createReducer(
  // Supply the initial state
  initialState, 
  // Handle list
  on(loadVersionsList, (state) => ({
    ...state,
    listStatus: "loading" as VersionState["listStatus"],
  })),
  // Handle successfully list
  on(loadVersionsListSuccess, (state, { data }) => {
    console.log('DATA VERSION LIST->', data)
    
    return {
      ...state,
      versions: data.results,
      error: null,     
      pagination: data.pagination,
      listStatus: "success" as VersionState["listStatus"]
    }
  }),
  // Handle failure list
  on(
    loadVersionsListFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    listStatus: "error" as VersionState["listStatus"],
  })),
  // Handle get selected
  on(getSelectedVersion, (state) => ({
    ...state,
    getStatus: "loading" as VersionState["getStatus"],
  })),
  // Handle successfully get selected
  on(getSelectedVersionSuccess, (state, { version }) => {    
    return {
      ...state,
      selectedVersion: version,
      error: null,
      getStatus: "success" as VersionState["getStatus"]
    }
  }),
  // Handle failure get
  on(
    getSelectedVersionFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    getStatus: "error" as VersionState["getStatus"],
  })),
   // Handle delete
   on(deleteVersion, (state) => ({
    ...state,
    deleteStatus: "loading" as VersionState["deleteStatus"]
  })),
  // Handle successfully delete
  on(deleteVersionSuccess, (state, { pk, sk }) => ({
    ...state,
    deleteStatus: "success" as VersionState["deleteStatus"],
    selectedVersion: state.selectedVersion.sk == sk ? null : state.selectedVersion,
    pagination : {
      ...state.pagination,
      total: state.pagination.total - 1
    },
    versions: [...state.versions.filter((version) => version.sk !== sk)],
  })),
  // Handle failure delete
  on(
    deleteVersionFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    deleteStatus: "error" as VersionState["deleteStatus"],
  })),
  // Handle add
  on(addVersion, (state) => ({
    ...state,
    createStatus: "loading" as VersionState["createStatus"]
  })),
  // Handle successfully add
  on(addVersionSuccess, (state, { version }) => {    
    return {
      ...state,
      versions: [version, ...state.versions],
      selectedVersion: version,
      pagination : {
        ...state.pagination,
        total: state.pagination.total + 1
      },
      createStatus: "success" as VersionState["createStatus"]
    }
  }),
  // Handle failure add
  on(
    addVersionFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    createStatus: "error" as VersionState["createStatus"],
  })),
  // Handle edit
  on(editVersion, (state) => ({
    ...state,
    updateStatus: "loading" as VersionState["updateStatus"]
  })),
  // Handle successfully edit
  on(editVersionSuccess, (state, { version }) => ({
    ...state,
    versions: state.versions.map((versionItem) =>
      versionItem.sk === version.sk && versionItem.pk === version.pk ? version : versionItem
    ),
    selectedVersion: version,
    updateStatus: "success" as VersionState["updateStatus"]
  })),
  // Handle failure edit
  on(
    editVersionFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    updateStatus: "error" as VersionState["updateStatus"],
  })),
);

